import { appendUrlParams } from '@/utils/generator'
import axios from './axios'

// fetch all games
export const gameIndex = async (payload = {}) => {
  // url query params
  const params = appendUrlParams({
    page: payload.page || 1,
    perPage: payload.perPage || 25,
    searchText: payload.search || '',
    sortBy: payload.sortBy || '',
    sortDesc: payload.sortDesc || '',
    user: payload.user || '',
  })
  const {
    data: { games, count },
  } = await axios.get(`/game?${params.toString()}`)
  return { games, count }
}
// fetch one game by id
export const fetchGameById = async id => {
  const { data } = await axios.get('/game/' + id)
  return data
}

// fetch my games
export const fetchUserGames = async () => {
  const { data } = await axios.get('/game/show-many')
  return data
}

// fetch json for local game
export const fetchLocalExport = async id => {
  const { data } = await axios.get('/game/local-export/' + id)
  return data
}

// fetch json for web game
export const fetchWebExport = async id => {
  const { data } = await axios.get('/game/web-export/' + id)
  return data
}
// stores one game
export const storeGame = async payload => {
  const { data } = await axios.post('/game', payload)
  return data
}

// destroys one game
export const destroyGame = async id => {
  await axios.delete('/game/' + id)
}
// updates one game by its id
export const updateGame = async payload => {
  const { data } = await axios.put('/game/' + payload._id, payload)
  return data
}

// replicate one game by its id
export const replicateGame = async id => {
  const { data } = await axios.post('/game/replicate/' + id)
  return data
}

export const transferCopy = async payload => {
  const { data } = await axios.post('/game/transfer-copy', payload)
  return data
}
